import styled, { css } from 'styled-components';
import { focusRing } from './mixins';

const buttonBase = css`
  border: 0;
  padding: 10px 16px;
  border-radius: 4px;
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  transition:
    color 0.2s ease-in-out,
    background-color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;

  cursor: pointer;
`;

export const primaryButton = css`
  ${buttonBase};
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  color: white;

  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimaryHover};
  }

  &:focus-visible {
    ${focusRing};
  }
`;

export const secondaryButton = css`
  ${buttonBase};
  background: white;
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.interactive.borderPrimaryDefault};

  &:hover {
    color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimaryHover};
    border-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimaryHover};
  }
`;

const baseButton = styled.button<{ disabled: boolean }>`
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  height: 40px;
  padding: 10px 24px;
  border-radius: 4px;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition:
    color 0.2s ease-in-out,
    background-color 0.2s ease-in-out;
`;

export const plainButton = styled(baseButton)<{ disabled?: boolean }>`
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  background-color: transparent;

  &:hover {
    color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
    background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer01};
  }

  &:active {
    color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundBrandContrastPressed};
    background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected};
  }

  &:focus-visible {
    ${focusRing};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      cursor: default;

      &:hover,
      &:active {
        color: ${({ theme }) => theme.kallisto.color.common.black[200]};
        background-color: transparent;
      }
    `}
`;

export const FilledButton = styled(baseButton)<{ disabled: boolean }>`
  color: white;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};

  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  }

  &:active {
    background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundBrandContrastPressed};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
      cursor: default;

      &:hover {
        background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
      }

      &:active {
        background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
      }
    `}
`;

export const MyPriceWhiteButton = styled(baseButton)`
  color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[500]};
  background-color: white;

  &:hover {
    color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[700]};
  }

  &:active {
    color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[700]};
  }
`;
